import Vue from 'vue';
import VeeValidate from 'vee-validate';
import ru from 'vee-validate/dist/locale/ru';

import App from './App.vue';
import router from './router';
import store from './store';

Vue.config.productionTip = false;

Vue.use(VeeValidate);

VeeValidate.Validator.localize('ru', ru);

VeeValidate.Validator.extend('verify_password', {
  getMessage: () => 'Поле должно содержать цифры и латинские буквы.',
  validate: (value) => {
    const regexp = new RegExp('^.*(?=.*\\d)(?=.*[a-zA-Z]).*$');

    return regexp.test(value);
  },
});

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
